import discovery from "@wkt/discovery";
import { httpClient } from "@wkt/lib/httpClient";

const UPDATE_CHECK_INTERVAL_MS = 5 * 60 * 1000;

function canUseWindow(): boolean {
  return typeof window !== "undefined";
}

function resolveHealthcheckUrl(): string | null {
  if (typeof discovery.worktime_service_url !== "string") {
    return null;
  }

  const serviceUrl = discovery.worktime_service_url.trim();
  if (!serviceUrl) {
    return null;
  }

  try {
    return new URL("testservice/health", serviceUrl).toString();
  } catch (_error) {
    return null;
  }
}

export function useAppUpdateMonitor() {
  let intervalId: number | null = null;

  async function checkForUpdates(): Promise<void> {
    if (!canUseWindow()) {
      return;
    }

    if (document.visibilityState === "hidden") {
      return;
    }

    const healthcheckUrl = resolveHealthcheckUrl();
    if (!healthcheckUrl) {
      return;
    }

    try {
      await httpClient.get(healthcheckUrl, {
        responseType: "text",
      });
    } catch (_error) {
      // The version interceptor already processes successful/error responses
      // when the backend returns X-SERVICE-VERSION. Poll failures are non-fatal.
    }
  }

  function start(): void {
    if (!canUseWindow() || intervalId != null) {
      return;
    }

    intervalId = window.setInterval(() => {
      void checkForUpdates();
    }, UPDATE_CHECK_INTERVAL_MS);
  }

  function stop(): void {
    if (!canUseWindow() || intervalId == null) {
      return;
    }

    window.clearInterval(intervalId);
    intervalId = null;
  }

  return {
    checkForUpdates,
    start,
    stop,
  };
}
